import React, { useRef, useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
//
import Pagination from '@mui/material/Pagination';
//
import { getImageUrl } from "utils/getImageUrl"
import { imageSize } from "utils/helper"
import { useSimpledText } from 'utils/useSimpledText'
import { makeStyles } from '@material-ui/styles';
import {
 Card,
 CardContent,
 Box,
 Chip,
 Typography,
 Grid
} from '@material-ui/core';
import Fab from '@mui/material/Fab';
import CreateIcon from '@material-ui/icons/Create';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';


export const PageNation = ({ data, page }) => {

 const [currentItems, setCurrentItems] = useState([]);
 const classes = useStyles();
 const { truncateText } = useSimpledText()

 useEffect(() => {
  setCurrentItems(data)
 }, [data]);


 return (
  <>
   <Box>
    <Grid container spacing={2}>
     {currentItems && currentItems.map((card, idx) => (
      <Grid key={idx} item xs={12} md={4}>
       <RouterLink
        to={{
         pathname: `/peloton/${card.uriName}`,
         state: { uriName: card.uriName }
        }}
       >
        <Card className={classes.card}>
         {(card.clubThumbFiles).length > 0 ?
          <Box style={{ position: 'relative' }}>
           <img
            className={classes.image} src={getImageUrl(card.clubThumbFiles, imageSize.LG)} alt="Peloton Image"
            style={card.myClubUserResponse && card.myClubUserResponse.join ? { border: '2px solid #4db6ac' } : {}}
           />
           {card.myClubUserResponse && !card.myClubUserResponse.join && (
            <Chip style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="가입 대기중" />
           )}
           {card.myClubUserResponse &&
            card.myClubUserResponse.join &&
            // card.myClubUserResponse?.clubRole !== 'ADMIN' && 
            (
             <Chip color="primary" style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="가입된 펠로톤" />
            )}
           {/* {card.myClubUserResponse?.clubRole === 'ADMIN' && (
            <Chip color="secondary" style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="내 펠로톤" />
           )} */}
          </Box>
          :
          <Box style={{ position: 'relative' }}>
           <img
            className={classes.image} src="images/dummy_box.png" alt="Peloton Image"
            style={card.myClubUserResponse && card.myClubUserResponse.join ? { border: '2px solid #4db6ac' } : {}}

           />
           {card.myClubUserResponse && !card.myClubUserResponse.join && (
            <Chip style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="가입 대기중" />
           )}
           {card.myClubUserResponse &&
            card.myClubUserResponse.join &&
            // card.myClubUserResponse?.clubRole !== 'ADMIN' && 
            (
             <Chip color="primary" style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="가입된 펠로톤" />
            )}
           {/* {card.myClubUserResponse?.clubRole === 'ADMIN' && (
            <Chip color="secondary" style={{ position: 'absolute', top: 160, left: 10, zIndex: 999 }} size="small" label="내 펠로톤" />
           )} */}
          </Box>
         }
         <CardContent>
          <Typography gutterBottom variant="h4" component="div">
           {truncateText(card.name, 30)}
          </Typography>
          <div className={classes.info}>
           <LocationOnIcon fontSize="small" />
           <Typography variant="body1">
            {card.country}
           </Typography>
           <PersonIcon />
           <Typography variant="body1">
            {card.userCount}
           </Typography>
          </div>
          <Typography variant="body2" color="textSecondary">
           {truncateText(card.description, 86)}
          </Typography>
         </CardContent>
        </Card>
       </RouterLink>
      </Grid>
     ))
     }
    </Grid>
   </Box>
   <Box style={{
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: "99"
   }}>
    <RouterLink
     to={{
      pathname: `/pelotons/create`,
     }}
    >
     <Fab
      color="primary"
      size="large"
      style={{
       backgroundColor: "#4DB6AC",
       width: "130px",
       borderRadius: "100px"
      }}
     >
      <Typography variant="h6" style={{ color: 'white' }}>
       펠로톤 생성
      </Typography>
      <CreateIcon style={{ color: "white", marginLeft: '8px' }} />
     </Fab>
    </RouterLink>
   </Box>
  </>
 )
}

const useStyles = makeStyles(theme => ({
 root: {
  // padding: theme.spacing(2),
 },
 topBar: {
  paddingBottom: '8px',
  marginBottom: '16px'
 },
 title: {
  fontSize: '16px',
  color: '#455A64',
  fontWeight: '700',
  padding: '0px',
  [theme.breakpoints.up('md')]: {
   fontSize: '16px'
  }
 },
 menu: {
  fontSize: '14px',
  color: '#455A64',
  fontWeight: '700',
  padding: '0px',
  [theme.breakpoints.up('md')]: {
   fontSize: '14px'
  }
 },
 card: {
  height: "100%"
 },
 textField: {
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
 },
 image: {
  height: '193px',
  width: '100%',
  objectFit: 'contain',
 },
 info: {
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  marginBottom: "16px",
  "& > *": {
   marginRight: "4px",
  },
 },
}));
